import { SCOPE } from 'js/config/consts';
import {
  MAX_SCRIBE_LENGTH_5M_IN_MS,
  MAX_SCRIBE_LENGTH_10M_IN_MS,
  MAX_SCRIBE_LENGTH_15M_IN_MS,
  MAX_SCRIBE_LENGTH_20M_IN_MS
} from 'js/config/defaults';
import { UserWithPermissions } from 'js/permissions/permissionsHelpers';

export const projectDurationLimitMs = (user: UserWithPermissions) => {
  let projectLengthLimit = MAX_SCRIBE_LENGTH_5M_IN_MS;

  if (user.can([SCOPE.create10mVideo])) {
    projectLengthLimit = MAX_SCRIBE_LENGTH_10M_IN_MS;
  }

  if (user.can([SCOPE.create15mVideo])) {
    projectLengthLimit = MAX_SCRIBE_LENGTH_15M_IN_MS;
  }

  if (user.can([SCOPE.create20mVideo])) {
    projectLengthLimit = MAX_SCRIBE_LENGTH_20M_IN_MS;
  }

  return projectLengthLimit;
};
